import { Typography, Grid } from "@mui/material";
import React from "react";
import "./aboutme.css";
import mephotu from "./photo.JPG";
import Photu from "./3d_Photu.png";

function Aboutme() {
  return (
    <div className="about_section">
      <Typography
        variant="h4"
        color={"#fff"}
        align="center"
        sx={{ margin: "50px" }}>
        About Me
      </Typography>
      <Grid
        container
        sx={{ display: "flex", justifyContent: "center" }}
        rowGap="30px">
        <Grid
          item
          xs={12}
          md={5}
          align="left"
          sx={{ color: "#fff" }}
          order={{ xs: 2, md: 1 }}>
          <Typography variant="p" sx={{ fontSize: "18px" }} lineHeight="30px">
            <span>&#128073;</span> Hello, My name is Divyesh vyas👋.A student of
            computer engineering at government engineering college gandhinagar.
            <br></br>
            <br></br> &#128073; I'm a web Development and competitive
            programming enthusiast. Having strong knowledge of the DSA Profile &
            Practice in Problem-solving. always ready to learn the latest
            Technology. Flexible to switching technologies.
            <br></br>
            <br></br> &#128073; Profficiency in MERN stack development and in
            love with C++.🤩
          </Typography>
        </Grid>
        <Grid item xs={12} md={5} align="center" order={{ xs: 1, md: 2 }}>
          {/* <div className="img-border"> */}
          <img src={Photu} width="70%" className="about-img"></img>
          {/* </div> */}
        </Grid>
      </Grid>
    </div>
  );
}

export default Aboutme;
